import { Navigate } from "react-router-dom";

const DefaultPage = () => <Navigate to="/" />;

export default DefaultPage;